import { Box, Grid } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { Logger, Section } from '@wolfdanepug/common-react'
import { useQuery } from '../lib/useQuery'
import { GetCart, GetUnstableData } from '../graphql/docs'
import ActionToggle from '../components/ActionToggle'
import Stripe from '../components/Stripe'
import Checkout from '../components/cart/Checkout'
import OrderSummary from '../components/OrderSummary'

export default function CheckoutPage() {
	const { data: cart, loading: cartLoading } = useQuery(GetCart)
	const { data: unstableData, loading: dataLoading } = useQuery(
		GetUnstableData,
		{ context: 'onboarding' },
		'cache-first'
	)

	useEffect(() => {
		Logger.log('[Page] Checkout cart', cart)
	}, [cart])

	const data = unstableData?.data
	useEffect(() => {
		Logger.log('[Page] Checkout data', data)
	}, [data])

	const coupon = useMemo(() => {
		if (cart?.discountCodes?.length > 0) {
			const code = cart.discountCodes[0]
			return cart.discountConfiguration.find((c: any) => c.code === code)
		}
		return null
	}, [cart])

	return (
		<>
			<ActionToggle />
			<Box sx={{ pt: { xs: 7, md: 10 }, pb: 15 }}>
				<Section>
					<Box>
						<Grid container spacing={7}>
							<Grid item md={5} sx={{ display: { xs: 'block', md: 'none' } }}>
								{cart && <OrderSummary cart={cart} coupon={coupon} total={cart?.total} />}
							</Grid>
							<Grid item md={7}>
								{cart && (
									<Stripe>
										<Checkout cart={cart} data={data} />
									</Stripe>
								)}
							</Grid>
							<Grid item md={5} sx={{ display: { xs: 'none', md: 'block' } }}>
								{cart && <OrderSummary cart={cart} coupon={coupon} total={cart?.total} />}
							</Grid>
						</Grid>
					</Box>
				</Section>
			</Box>
		</>
	)
}

const styles = {
	discounted: {
		textDecoration: 'line-through'
	},
	green: {
		color: 'green'
	}
}
